import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import FunnelTimeIcon from '@rsuite/icons/FunnelTime';
import ExportIcon from '@rsuite/icons/Export';
import MoreIcon from '@rsuite/icons/More';
import { Icon } from '@rsuite/icons';
import SortDownIcon from '@rsuite/icons/SortDown';
import ArrowRightLineIcon from '@rsuite/icons/ArrowRightLine';
import AttachmentIcon from '@rsuite/icons/Attachment';
import CopyIcon from '@rsuite/icons/Copy';
import TrashIcon from '@rsuite/icons/Trash';
import ReviewRefuseIcon from '@rsuite/icons/ReviewRefuse';
import TagIcon from '@rsuite/icons/Tag';
import {
  Input,
  InputGroup,
  Button,
  Form,
  CheckPicker,
  Checkbox,
  Stack,
  CheckboxGroup,
  Breadcrumb,
  Divider,
  Panel,
  Col,
  FlexboxGrid,
  Container,
  Notification,
  useToaster,
  AvatarGroup,
  Avatar,
  Modal,
  Loader,
  Badge,
  SelectPicker,
  IconButton,
  Table,
  ButtonToolbar,
  Whisper,
  Popover,
  Dropdown
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import DrawerView from './DrawerView';
import { PlacementType } from 'rsuite/esm/toaster/ToastContainer';
import { MessageType } from 'rsuite/esm/Notification/Notification';
import { mockUsers } from '@/data/mock';
import AdminIcon from '@rsuite/icons/Admin';
import FormControlLabel from 'rsuite/esm/FormControlLabel';
import EditIcon from '@rsuite/icons/Edit';


const { Column, HeaderCell, Cell } = Table;
const data = mockUsers(8);

const data2 = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M'];



const ManageCatalogue = () => {



  const [sortColumn, setSortColumn] = React.useState();
  const [sortType, setSortType] = React.useState();
  const [loading, setLoading] = React.useState(false);

  const getData = () => {
    if (sortColumn && sortType) {
      return data.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string") {
          x = x.charCodeAt();
        }
        if (typeof y === "string") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
    return data;
  };

  const handleSortColumn = (sortColumn, sortType) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
  };


  // Scanning Modal function Start
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // Scanning Modal function End

  // Message start
  const [type, setType] = React.useState('success' as MessageType);
  const [placement, setPlacement] = React.useState('bottomEnd' as PlacementType);


  const toaster = useToaster();

  const Cell1 = () => {
    return (
      <Button appearance='ghost' color='cyan'>Active</Button>
    )
  }
  const Buyer = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
       
      <ButtonToolbar>
        <Button appearance="subtle" active><Icon style={{ 'width': '30px', 'height': '17px', 'color': 'cadetblue' }} as={AdminIcon} />
          Shortlisted
        </Button>
      </ButtonToolbar>
    </Cell>
  );
    const Buyer1 = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <FormControlLabel>---</FormControlLabel>
    </Cell>
  );

  const Active = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <Button
        appearance="ghost" active color='cyan'
      > Active</Button>
    </Cell>
  );
  const Catalogue = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <b>Summer Collection for 2022</b>
      <p>6 Products</p>
      <p>Generated by erpdaddy.com Monday at 2:30 PM </p>
    </Cell>
  );
  const Active1 = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <Button
        appearance="subtle" active color='orange'
      > Draft</Button>
    </Cell>
  );
  const renderMenu1 = ({ onClose, left, top, className }, ref) => {
    const handleSelect = eventKey => {
      onClose();
      console.log(eventKey);
    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item eventKey={1}>Download PPT<Icon as={SortDownIcon} /></Dropdown.Item>
          <Dropdown.Item eventKey={2}>Download Excel <Icon as={SortDownIcon} /></Dropdown.Item>

        </Dropdown.Menu>
      </Popover>
    );
  };
  const renderMenu = ({ onClose, left, top, className }, ref) => {
    const handleSelect = eventKey => {
      onClose();
      console.log(eventKey);
    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect} >
          <Dropdown.Item ><Stack justifyContent='space-between' ><Stack direction='row' alignItems='flex-start' spacing={8}><Icon as={TagIcon} /><Stack direction='column' alignItems='flex-start'><b>Create Quotation</b><p>You can maintain a list of all quotation </p><p> generated angaist buyer</p></Stack></Stack><Stack><Icon as={ArrowRightLineIcon} /></Stack></Stack></Dropdown.Item>
          <Dropdown.Item ><Stack justifyContent='space-between'><Stack direction='row' alignItems='flex-start' spacing={8}><Icon as={ReviewRefuseIcon} /><Stack direction='column' alignItems='flex-start'><b>Deactivate Catalogue Link</b><p>Link will be deactivated and you can </p><p>activate it again later</p></Stack></Stack><Stack><Icon as={ArrowRightLineIcon} /></Stack></Stack></Dropdown.Item>
          <Dropdown.Item ><Stack justifyContent='space-between' spacing={10}><Stack direction='row' alignItems='flex-start' spacing={8}><Icon as={AttachmentIcon} /><Stack direction='column' alignItems='flex-start'><b>Updata Link Settings</b><p>Change settings for passsword security</p> <p>and expiry date</p></Stack></Stack><Stack><Icon as={ArrowRightLineIcon} /></Stack></Stack></Dropdown.Item>
          <Dropdown.Item ><Stack justifyContent='space-between'><Stack direction='row' alignItems='flex-start' spacing={8}><Icon as={CopyIcon} /><Stack direction='column' alignItems='flex-start'><b>Creae a copy of this catalogue</b><p>A copy of this catalogue will be </p><p> created with same products</p></Stack></Stack><Stack><Icon as={ArrowRightLineIcon} /></Stack></Stack></Dropdown.Item>
          <Dropdown.Item ><Stack justifyContent='space-between'><Stack direction='row' alignItems='flex-start' spacing={8}><Icon as={TrashIcon} /><Stack direction='column' alignItems='flex-start'><b>Delete this catalogue</b><p>Permanantly delete this catalogue </p> <p> you cannot restore them later</p></Stack></Stack><Stack><Icon as={ArrowRightLineIcon} /></Stack></Stack></Dropdown.Item>
        </Dropdown.Menu>
      </Popover>
    );
  };

  const ActionCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props} className="link-group">
        <Whisper placement="auto" trigger="click" speaker={renderMenu}>
          <IconButton appearance="subtle" style={{ marginTop: '-8px' }} active icon={<MoreIcon />} />
        </Whisper>
      </Cell>
    );
  };
  const Controls = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <Stack spacing={5}>
        <Button
          appearance="subtle" active
        > Active</Button>
        <Button
          appearance="subtle" active
        > Preview</Button>
        <Whisper placement="autoVerticalStart" trigger="click" speaker={renderMenu1}>
          <IconButton icon={<ExportIcon />} active />
        </Whisper>
      </Stack>
    </Cell>
  );
  const Controls1 = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <Stack spacing={5}>
        <Whisper placement="autoVerticalStart" trigger="click" speaker={renderMenu1}>
          <IconButton icon={<EditIcon />} active />
        </Whisper>
      </Stack>
    </Cell>
  );


  const [value, setValue] = React.useState([]);

  const handleCheckAll1 = (value, checked) => setValue(checked ? data2 : []);
  const handleChange1 = value => setValue(value);

  const [showDrawer, setShowDrawer] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');

  const buyer = ['All Buyers'].map(
    item => ({ label: item, value: item })
  );
  const AddedOn = ['All Time', 'Today', 'Yesterday', 'This week', 'Last week', 'This month', 'Last month', 'Last 3 month', 'Last 6 month'].map(
    item => ({ label: item, value: item })
  );
  const [selectedOption, setSelectedOption] = useState('Option 1');

  const handleOptionChange = (value) => {
    setSelectedOption(value);
  };



  return (
    <>
      <Container className='main'>
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start'>
            <Stack direction='column' alignItems='flex-start' >
              <Badge color="cyan" content={966}><h3 className="title">All Catalogues</h3></Badge>
              <Breadcrumb>
                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                <Breadcrumb.Item active>All Catalogues</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Stack spacing={10} >
              <Stack direction='column' alignItems='flex-start' >
                <label>Buyer</label>
                <SelectPicker data={buyer} size="xs" appearance="default" placeholder="Buyer" style={{ width: 200 }} />
              </Stack>
              <Stack direction='column' alignItems='flex-start' >
                <label>User</label>
                <SelectPicker data={[]} size="xs" appearance="default" placeholder="User" style={{ width: 200 }} />
              </Stack>
              <Stack direction='column' alignItems='flex-start' >
                <label>Status</label>
                <SelectPicker value={selectedOption}
                  onChange={handleOptionChange}
                  data={[
                    { label: 'All Catalogues (966)', value: 'Option 1' },
                    { label: 'Draft (183)', value: 'Option 2' },
                    { label: 'Active (755)', value: 'Option 3' },
                    { label: 'Inactive (28)', value: 'Option 4' }
                  ]} size="xs" appearance="default" placeholder="Status" style={{ width: 150 }} />
              </Stack>
              <Stack direction='column' alignItems='flex-start'>
                <label>Created On</label>
                <SelectPicker data={AddedOn} size="xs" appearance="default" placeholder="Updated On" style={{ width: 150 }} />
              </Stack>
{/*               
                {selectedOption === 'Option 1' && (
                  <p>This is the content for Option 1</p>
                )}
                {selectedOption === 'Option 2' && (
                  <p>This is the content for Option 2</p>
                )}
                {selectedOption === 'Option 3' && (
                  <p>This is the content for Option 3</p>
                )}
               */}
            </Stack>
          </Stack>


          <Stack direction='column' alignItems='flex-end' spacing={44}>
            <Stack direction='row' spacing={5}>
              <InputGroup inside >
                <Input placeholder="Search" value={searchKeyword} onChange={setSearchKeyword} />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
              <Button appearance="default" active>
                <SearchIcon /> Smart Search
              </Button>
            </Stack>
            <Stack >
              <Stack direction='column' alignItems='flex-start'>
                <label>Sort</label>
                <IconButton icon={<FunnelTimeIcon />} active placement="right" >
                  Recantly Created
                </IconButton>

              </Stack>
            </Stack>
          </Stack>
        </Stack>
        
        <Divider className='divide' />
        <div style={{ 'marginLeft': '18px', 'marginTop': '10px' }}>
          <span ><b>Showing 966 Catalogues</b></span>
        </div>
        <div className="row">
          <Panel>
          {selectedOption === 'Option 1' && (
             <Table height={420}
             data={getData()}
             sortColumn={sortColumn}
             sortType={sortType}
             onSortColumn={handleSortColumn}
             loading={loading} id="table">

             <Column width={400} align="center" sortable>
               <HeaderCell>Catalogue Details</HeaderCell>
               <Catalogue dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
             </Column>

             <Column width={250}>
               <HeaderCell>Status</HeaderCell>
               <Active dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
             </Column>

             <Column width={250}>
               <HeaderCell>Buyer Details</HeaderCell>
               <Cell dataKey="name" />
             </Column>

             <Column width={250}>
               <HeaderCell>Buyer Activity</HeaderCell>
               <Buyer dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
             </Column>


             <Column width={200}>
               <HeaderCell>Controls</HeaderCell>
               <Controls dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
             </Column>

             <Column width={50}>
               <HeaderCell>

               </HeaderCell>
               <ActionCell dataKey="id" rowData={undefined} />
             </Column>

           </Table>
           )}

            {selectedOption === 'Option 2' && (
                  <Table height={420}
                  data={getData()}
                  sortColumn={sortColumn}
                  sortType={sortType}
                  onSortColumn={handleSortColumn}
                  loading={loading} id="table">
     
                  <Column width={400} align="center" sortable>
                    <HeaderCell>Catalogue Details</HeaderCell>
                    <Catalogue dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                  </Column>
     
                  <Column width={250}>
                    <HeaderCell>Status</HeaderCell>
                    <Active1 dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                  </Column>
     
                  <Column width={250}>
                    <HeaderCell>Buyer Details</HeaderCell>
                    <Cell dataKey="name" />
                  </Column>
     
                  <Column width={250}>
                    <HeaderCell>Buyer Activity</HeaderCell>
                    <Buyer1 dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                  </Column>
     
     
                  <Column width={200}>
                    <HeaderCell>Controls</HeaderCell>
                    <Controls1 dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                  </Column>
     
                  <Column width={50}>
                    <HeaderCell>
     
                    </HeaderCell>
                    <ActionCell dataKey="id" rowData={undefined} />
                  </Column>
     
                </Table>
                )}

            
            {/* <Table
      height={420}
      data={getData()}
      sortColumn={sortColumn}
      sortType={sortType}
      onSortColumn={handleSortColumn}
      loading={loading}
    >
      <Column width={400} align="center" fixed sortable>
        <HeaderCell>Catalogue Details</HeaderCell>
        <Cell dataKey="id" />
      </Column>

      <Column width={250} >
        <HeaderCell>Status</HeaderCell>
        <Active dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
      </Column>

      <Column width={250}>
        <HeaderCell>Buyer Details</HeaderCell>
        <Cell dataKey="name" />
      </Column>

      <Column width={250}>
        <HeaderCell>Buyer Activity</HeaderCell>
        <Buyer dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
      </Column>

      <Column width={300}>
        <HeaderCell>Controls</HeaderCell>
        <Controls dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
      </Column>
    </Table> */}
          </Panel>
        </div>

        <Stack className="copyright" justifyContent="space-between" style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
          <div className="container">
            <p>© All Right Reserved. Product by </p>
          </div>
          <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
        </Stack>
        <DrawerView open={showDrawer} onClose={() => setShowDrawer(false)} />
      </Container>
    </>
  );
};

export default ManageCatalogue;